<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver al listado de U.I.">
            <i class="fa fa-chevron-left"></i></button>
        <button *ngIf="hasAddingAccess" [disabled]="actionNotAllowed" class="btn btn-outline-success" type="button" (click)="onAdd()" title="Nuevo">
            <i class="fa fa-file-o"></i> Nuevo
        </button>
    </form>
</nav>

<div class="container-fluid container-list">
    <h4 class="pt-3">Documentos de la Unidad de Inspección</h4>

    <app-unidad-inspeccion-header *ngIf="unidadInspeccion?.FirstRecinto" [formGroup]="formGroup" [unidadInspeccion]="unidadInspeccion"></app-unidad-inspeccion-header>

    <app-documento-ui-list *ngIf="documentosUI" [result]="documentosUI" [title]="title" 
            [hasDeletingAccess]="hasDeletingAccess" [hasViewingAccess]="hasViewingAccess"
            [idUsuario]="idUsuarioActual" (view)="onView($event)" (delete)="onDelete($event)"></app-documento-ui-list>
</div>
